export class PeriodReportService {
  static $inject = ['$resource'];

  private resource: any;

  constructor($resource) {
    this.resource = $resource('/api/reports/:year/:month');
  }

  query(params) {
    return this.resource.query(params).$promise;
  }
}
